export default __webpack_public_path__ + "static/media/13.f08d7ec4.mp3";